import {
  BetweenHorizontalStart,
  BetweenVerticalEnd,
  Copy,
  Download,
  ExternalLink,
  Trash2,
} from 'lucide-react';
import { useCallback } from 'react';
import { Button } from 'ui/components';

type FileCardPopoverProps = {
  url: string;
  view: 'inline' | 'block';
  switchView: () => void;
};

export default function FileCardPopover({
  url,
  view,
  switchView,
}: FileCardPopoverProps) {
  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(url);
  }, [url]);

  return (
    <div className="flex space-x-1">
      <Button
        onClick={() => {
          if (view === 'inline') {
            switchView();
          }
        }}
        variant="ghost"
        className={view !== 'inline' ? 'bg-gray-100' : ''}
        size="sm"
        toolTipPortal
        tooltip="Convert to block"
      >
        <BetweenHorizontalStart className="h-4 w-4" />
      </Button>
      <Button
        onClick={() => {
          if (view === 'block') {
            switchView();
          }
        }}
        variant="ghost"
        className={view !== 'block' ? 'bg-gray-100' : ''}
        size="sm"
        toolTipPortal
        tooltip="Convert to inline"
      >
        <BetweenVerticalEnd className="h-4 w-4" />
      </Button>
      <Button
        onClick={() => window.open(url, '_blank')}
        variant="ghost"
        size="sm"
        toolTipPortal
        tooltip="Download file"
      >
        <Download className="h-4 w-4" />
      </Button>
      <Button
        onClick={() => window.open(url, '_blank')}
        variant="ghost"
        size="sm"
        toolTipPortal
        tooltip="Open file in new tab"
      >
        <ExternalLink className="h-4 w-4" />
      </Button>
      <Button
        onClick={handleCopy}
        variant="ghost"
        size="sm"
        toolTipPortal
        tooltip="Copy file link"
      >
        <Copy className="h-4 w-4" />
      </Button>

      <Button variant="ghost" size="sm" toolTipPortal tooltip="Delete file">
        <Trash2 className="h-4 w-4" />
      </Button>
    </div>
  );
}
